<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-container>
            <el-main style="overflow: auto;height: calc(100vh - 80px);">
              <h2>购买人信息</h2>
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="联系人">
                  <label>{{orderInfo.linkman}}</label>
                </el-form-item>
                <el-form-item label="联系电话">
                  <label>{{orderInfo.linkPhone}}</label>
                </el-form-item>
                <el-form-item label="展会名称">
                  <label>{{orderInfo.exhibitionName}}</label>
                </el-form-item>
                <el-form-item label="展会号">
                  <label>{{orderInfo.boothNumber}}</label>
                </el-form-item>
                <el-form-item label="订单备注">
                  <label>{{orderInfo.remark}}</label>
                </el-form-item>
              </el-form>

              <h2>订单信息</h2>
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="订单号">
                  <label>{{orderInfo.orderNum}}</label>
                </el-form-item>
                <el-form-item label="订单状态">
                  <label v-if="orderInfo.status == 1">待支付</label>
                  <label v-if="orderInfo.status == 2">使用中</label>
                  <label v-if="orderInfo.status == 3">退押金</label>
                  <label v-if="orderInfo.status == 4">已完成</label>
                  <label v-if="orderInfo.status == 5">已取消</label>
                </el-form-item>
                <el-form-item label="押金状态">
                  <label v-if="orderInfo.cashPledgeStatus == 0">正常</label>
                  <label v-if="orderInfo.cashPledgeStatus == 1">待检验</label>
                  <label v-if="orderInfo.cashPledgeStatus == 2">待审核</label>
                  <label v-if="orderInfo.cashPledgeStatus == 3">已退款</label>
                  <label v-if="orderInfo.cashPledgeStatus == 4">已拒绝</label>
                </el-form-item>
                <el-form-item label="订单总金额">
                  <label>￥{{orderInfo.totalFee}}</label>
                </el-form-item>
                <el-form-item label="订单押金">
                  <label>￥{{orderInfo.totalCashPledge}}</label>
                </el-form-item>
                <el-form-item label="所属类目">
                  <label v-if="orderInfo.typeId == 1">服务类</label>
                  <label v-if="orderInfo.typeId == 2">工程类</label>
                  <label v-if="orderInfo.typeId == 3">餐饮类</label>
                  <label v-if="orderInfo.typeId == 4">租赁类</label>
                </el-form-item>
                <el-form-item label="下单时间">
                  <label>{{orderInfo.createTime|timestampToTime}}</label>
                </el-form-item>
                <el-form-item label="支付时间">
                  <label>{{orderInfo.payTime|timestampToTime}}</label>
                </el-form-item>
              </el-form>

              <h2>开票信息</h2>
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="发票类型">
                  <label v-if="orderInfo.billType == 1">定额</label>
                  <label v-if="orderInfo.billType == 2">普票</label>
                  <label v-if="orderInfo.billType == 3">专票</label>
                </el-form-item>
                <el-form-item label="开票金额">
                  <label>￥{{orderInfo.billPrice}}</label>
                </el-form-item>
                <el-form-item label="发票抬头">
                  <label>{{orderInfo.billHeader}}</label>
                </el-form-item>
                <el-form-item label="发票纳税编号">
                  <label>{{orderInfo.billNumber}}</label>
                </el-form-item>
                <el-form-item label="地址信息">
                  <label>{{orderInfo.billAddress}}</label>
                </el-form-item>
                <el-form-item label="注册电话">
                  <label>{{orderInfo.billPhone}}</label>
                </el-form-item>
                <el-form-item label="开户行">
                  <label>{{orderInfo.openingBank}}</label>
                </el-form-item>
                <el-form-item label="银行账号">
                  <label>{{orderInfo.bankAccount}}</label>
                </el-form-item>
                <el-form-item label="备注说明">
                  <label>{{orderInfo.billRemark}}</label>
                </el-form-item>
                <el-form-item label="收件人">
                  <label>{{orderInfo.recipients}}</label>
                </el-form-item>
                <el-form-item label="收件人电话">
                  <label>{{orderInfo.recipientsPhone}}</label>
                </el-form-item>
                <el-form-item label="收件地址">
                  <label>{{orderInfo.recipientsAddress}}</label>
                </el-form-item>
              </el-form>


              <h2>商品明细</h2>
              <el-table :data="orderInfo.orderDetails" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                        border element-loading-text="拼命加载中" highlight-current-row
                        ref="userTable" size="small" style="width: 90%;margin-left: 20px;">
                <el-table-column label="商品名称" prop="commodityName">
                </el-table-column>
                <el-table-column label="数量" prop="amount">
                </el-table-column>
                <el-table-column label="单价" prop="sellingPrice">
                </el-table-column>
                <el-table-column label="押金" prop="cashPledge">
                </el-table-column>
                <el-table-column label="用餐日期" prop="mealDate" v-if="orderInfo.typeId == 3">
                  <template slot-scope="scope">
                    <div>{{scope.row.mealDate|timestampToTime}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="使用天数" prop="days" v-if="orderInfo.typeId == 2">
                </el-table-column>
              </el-table>


              <h2>押金退款</h2>
              <el-table :data="orderInfo.refundOrders" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                        border element-loading-text="拼命加载中" highlight-current-row
                        ref="userTable" size="small" style="width: 90%;margin-left: 20px;">
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <label v-if="scope.row.status == 0">正常</label>
                    <label v-if="scope.row.status == 1">待检验</label>
                    <label v-if="scope.row.status == 2">待审核</label>
                    <label v-if="scope.row.status == 3">退款中</label>
                    <label v-if="scope.row.status == 4">已拒绝</label>
                    <label v-if="scope.row.status == 5">已完成</label>
                  </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark">
                </el-table-column>
                <el-table-column label="退款状态">
                  <template slot-scope="scope">
                    <label v-if="scope.row.auditResult == 0">拒绝退款</label>
                    <label v-if="scope.row.auditResult == 1">同意退款</label>
                  </template>
                </el-table-column>
                <el-table-column label="检察员姓名" prop="inspector">
                </el-table-column>
                <el-table-column label="审核人姓名" prop="verifier">
                </el-table-column>
                <el-table-column label="操作时间" prop="timestampToTime">
                  <template slot-scope="scope">
                    <div>{{scope.row.createTime|timestampToTime}}</div>
                  </template>
                </el-table-column>
              </el-table>


              <div style="text-align: center;" >
                <el-button type="primary" @click="out">返回</el-button>
              </div>

            </el-main>
        </el-container>
    </div>
</template>

<script>

    export default {
        name: "orderDetail",
        data() {
            return {
                orderInfo:{}
            }
        },
        mounted() {
            if(this.$route.query.orderInfo){
                this.orderInfo = this.$route.query.orderInfo;
                this.$forceUpdate();
            }
            console.log("this.orderInfo",this.orderInfo)
        },
        methods:{

          out(){
            this.$router.push({ path: '/convenience/orderList',query:{page:this.$route.query.page}})
          },

            timestampToTime(timestamp) {
                let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear() + '-'
                let M =
                    (date.getMonth() + 1 < 10 ?
                        '0' + (date.getMonth() + 1) :
                        date.getMonth() + 1) + '-'
                let D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                let h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                let m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':'
                let s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
                return Y + M + D + h + m + s
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/convenience/orderDetail.vue